import type { ItemVariation } from '@kimuno/api-sdk/lib/types/responses/Collection';
import { useCallback } from 'react';

import {
	pinMindItem as pinMindItemAction,
	pinProduct as pinProductAction,
	unpinDocument as unpinDocumentAction,
} from '../actions/pinned.actions';
import useAction from './useAction';

const usePinAction = (itemId: string, isPinned: boolean | undefined, type: ItemVariation) => {
	const pinMindItem = useAction(pinMindItemAction);
	const pinProduct = useAction(pinProductAction);
	const unpinDocument = useAction(unpinDocumentAction);

	// biome-ignore lint/correctness/useExhaustiveDependencies: pre-Biome hook deps kept as-is; changing the deps list alters effect timing
	const action = useCallback(() => {
		if (isPinned === true) {
			return unpinDocument(itemId, type);
		}
		if (isPinned === false) {
			if (type === 'product') {
				return pinProduct(itemId);
			}

			return pinMindItem(itemId);
		}
		return;
	}, [itemId, isPinned]);

	return action;
};

export default usePinAction;
